itsoftApp.createModule("cookie", function () {
    const module = this;

    const Cookie = function () {
        this.MAX_DATE = 2000000000;
        this.SESSION_DATE = 86400;
    };

    Cookie.prototype.setCookie = function (element, date) {
        const dAttrSave = element.getAttribute("data-save");
        let dAttrExpires = element.getAttribute("data-expires");

        if (date) {
            if (date == 'day') {
                document.cookie = dAttrSave + "=yes; path=/; max-age=" + this.SESSION_DATE;
            } else {
                document.cookie = dAttrSave + "=yes; path=/; max-age=" + date;
            }
        } else if (dAttrExpires) {
            if (dAttrExpires === "max") {
                dAttrExpires = this.MAX_DATE;
            }
            document.cookie = dAttrSave + "=yes; path=/; max-age=" + dAttrExpires;
        } else {
            document.cookie = dAttrSave + "=yes; path=/"; /* одна сессия */
        }
    };

    Cookie.prototype.getCookie = function (element) {
        const dAttrSave = element.getAttribute("data-save");
        const matches = document.cookie.match(new RegExp("(?:^|; )" + dAttrSave.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    };

    Cookie.prototype.deleteCookie = function (element) {
        this.setCookie(element, {
            "max-age": -1
        }, "");
    };

    const cookieItem = new Cookie();

    module.setCookie = cookieItem.setCookie;
    module.getCookie = cookieItem.getCookie;
    module.deleteCookie = cookieItem.deleteCookie;
});
